import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { WebhookMessageViewComponent } from './webhook-message-view/webhook-message-view.component';
import { WebhookRoutingModule } from './webhook-routing.module';
import { WebhookViewComponent } from './webhook-view/webhook-view.component';
import { WebhookComponent } from './webhook.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    WebhookRoutingModule,
  ],
  declarations: [
    WebhookComponent,
    WebhookViewComponent,
    WebhookMessageViewComponent,
  ],
  exports: [
    WebhookComponent,
    WebhookViewComponent,
    WebhookMessageViewComponent,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class WebhookModule { }
